(function () {
	'use strict';

	angular.module('mx.components').directive('mxTextArea', function mxTextAreaDirective() {
		const directive = new mx.components.FormControlBase(MxTextAreaCtrl, 'mx-text-area/mx-text-area.html');
		angular.extend(directive.bindToController, {
			rows: '@',
		});
		return directive;
	});

	MxTextAreaCtrl.$inject = ['$timeout', '$element', '$scope'];

	function MxTextAreaCtrl($timeout, $element, $scope) {
		var vm = this;

		vm.$onInit = function () {
			mx.components.FormControlControllerBase.call(vm, $timeout);
			vm.rows = vm.rows || 4;
		};

		$scope.$watch('vm.label', function (value) {
			vm._label = value;
		});

		vm.$postLink = function () {
			var textArea = $element.find('textarea');
			textArea.on('blur', function () {
				$element.blur();
				vm.showingHints(false);
			});
			textArea.on('focus', function () {
				$element.triggerHandler('focus');
				vm.showingHints(true);
			});
			// Important: fix broken errors onPaste for absolute
			textArea.on('paste', function () {
				$element.triggerHandler('blur');
				$element.triggerHandler('focus');
			});
		};

		return vm;
	}
})();
